import FileUploader from "./fileuploader";

function App() {
  return (
    <div>
      <h1 style={{ textAlign: "center" }}>React File Upload</h1>
      <FileUploader />
    </div>
  );
}

export default App;
